import React from 'react'

function PaymentPage() {
  return (
    <div>
      <h1>Payment</h1>
    </div>
  )
}

export default PaymentPage
